import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { Context as ReactContext, useCallback, useContext, useState } from 'react';

import { IProvisioningStatusItem } from '../../Common/ProvisioningModels/ProvisioningStatus';

interface RetryResult {
  correlationId: string;
  message: string;
}

export function useProvisioningRetry(): [
  (item: IProvisioningStatusItem) => void,
  boolean,
  string | null,
  string | null,
  () => void,
] {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);

  const reset = useCallback(() => {
    setError(null);
    setSuccessMessage(null);
  }, []);

  const retry = useCallback(
    (item: IProvisioningStatusItem) => {
      setLoading(true);
      setError(null);
      setSuccessMessage(null);

      const entityTypeIds = item.entityTypeIds
        ? item.entityTypeIds.split(',').map((id) => id.trim()).filter(Boolean)
        : [];

      httpClient
        .post<RetryResult>(`${__API_BASE_URL__}/provisioning/retry`, {
          resource: __CLIENT_ID__,
          headers: { 'Content-Type': 'application/json' },
          data: {
            requestId: item.requestId,
            correlationId: item.correlationId,
            subjectType: item.subjectType,
            subjectId: item.subjectId,
            action: item.action,
            egressChannel: item.egressChannel,
            requestSource: item.requestSource,
            requestReason: item.requestReason,
            environment: item.environment,
            entityTypeIds,
          },
        })
        .then(({ data }) => {
          setSuccessMessage(`Retry queued. Correlation ID: ${data.correlationId}`);
          setLoading(false);
        })
        .catch((err) => {
          setError(err?.message || 'Failed to retry provisioning.');
          setLoading(false);
        });
    },
    [httpClient]
  );

  return [retry, loading, error, successMessage, reset];
}
